// extracted by mini-css-extract-plugin
module.exports = {"popup":"Tooltip_popup__2eZHP","surface":"Tooltip_surface__3p7sL","container":"Tooltip_container__1VoMq","arrow":"Tooltip_arrow__25VoY"};